export default __webpack_public_path__ + "static/media/No-Image-Placeholder.10da41b8.png";